export const fixJsonString = (jsonString) => {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.error("Erro ao tentar parsear JSON:", error.message);

    let fixedString = jsonString.replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');

    fixedString = fixedString.replace(/,\s*([\]}])/g, '$1');

    const openBraces = (fixedString.match(/{/g) || []).length;
    const closeBraces = (fixedString.match(/}/g) || []).length;
    const openBrackets = (fixedString.match(/\[/g) || []).length;
    const closeBrackets = (fixedString.match(/]/g) || []).length;

    if (openBraces > closeBraces) {
      fixedString += '}'.repeat(openBraces - closeBraces);
    }
    if (openBrackets > closeBrackets) {
      fixedString += ']'.repeat(openBrackets - closeBrackets);
    }

    try {
      return JSON.parse(fixedString);
    } catch (secondError) {
      console.error("Erro após tentativa de correção:", secondError.message);
      return null;
    }
  }
}